import { render, staticRenderFns } from "./MarketingMailingsBlock.vue?vue&type=template&id=179d86de&scoped=true"
import script from "./MarketingMailingsBlock.vue?vue&type=script&lang=js"
export * from "./MarketingMailingsBlock.vue?vue&type=script&lang=js"
import style0 from "./MarketingMailingsBlock.vue?vue&type=style&index=0&id=179d86de&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "179d86de",
  null
  
)

export default component.exports